
<section class="panel popup-panel panel-preferences" [@onPanelStatusChange]="statusPanel" (onClickOutside)="closePanel()">
  <div class="head">
    <p class="typo fw500">{{ title }}</p>
    <button mat-icon-button (click)="closePanel()" class="custom-mat-icon-button">
      <mat-icon matSuffix svgIcon="ico-close" class="custom-mat-icon ico-size ico-2xs"></mat-icon>
    </button>
  </div>
  <div cdkDropList class="list-popup-preferences" (cdkDropListDropped)="onDropGridPreferenceOption($event)">
    <div cdkDrag *ngFor="let column of collectionOfGridColumn" [cdkDragDisabled]="!column.editable" [class]="'custom-mat-list-item'">
      <div *cdkDragPlaceholder class="custom-mat-list-item-placeholder"></div>
      <mat-checkbox [checked]="column.checked" [disabled]="!column.editable" (change)="_meta.onChangeGridColumnsPreferences($event,column)" class="custom-mat-checkbox checkbox-simple-line" color="primary">{{ column.label }}</mat-checkbox>
      <button cdkDragHandle mat-icon-button *ngIf="column.editable" class="custom-mat-icon-button button-drag" >
        <mat-icon svgIcon="ico-drag" class="custom-mat-icon ico-size ico-1xs"></mat-icon>
      </button>
    </div>
  </div>
</section>
